export default "__VITE_ASSET__D351vb2Z__"